import React from "react";

function TextFieldR(props) {
  const [value, setValue] = React.useState(null);
  React.useEffect(() => {
    if (props.value) {
      setValue(props.value.replace(/['"]+/g, "").toLocaleString('en-IN'));
    }
    // else{
    //   setValue(0);
    // }
  }, []);

  
  const onChange = (e) => {
    document.getElementById('param'+props.id).removeAttribute('style');
    const value = e.target.value;

    // Only allow numbers
    if (!isNaN(value)) {
    setValue(e.target.value);

    props.data.find((item) => item.ParameterId === props.id).Value=value;
    // props.setData(
    //   props.data.map((item) => {
    //     return item.ParameterId === props.id
    //       ? { ...item, Value: e.target.value }
    //       : item;
    //   })
    // );
    }
  };
  
    return (
      <div class="form-group  col-md-3">
      
        <label >{props.name}<span style={{color:"red", fontsize:"23px"}}>*</span></label>
        <input
          type="text"
          value={value}
          onChange={onChange}
          id={'param' + props.id}
          //placeholder={props.name}
          class="form-control"
        />
      </div>
    );
  }


export default TextFieldR;

